const doc = [({"en":({"js":({"admin":({"components":({"photo_session_csvs":({"table":({"file":"File"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;